import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { requestAccessFromAdmin } from '../../../../stores/global-errors-display/global-errors-display-actions';
import { CircularProgress } from 'material-ui';
import R from 'ramda';

const NoLocs = props => {
  const {
    corporateAccess,
    requestingAccess,
    requestAccessError,
    requestAccess,
    companyType,
    firstName,
    lastName,
  } = props;

  return (
    <div style={{ textAlign: 'center', fontSize: '24px', padding: '5%' }}>
      You do not have any locations.
      <br/><br/>
      {
        R.contains('createLocation', corporateAccess) ?
          <div style={{ fontSize: '14px' }}>Please click <a href={'/profile'} style={{ cursor: 'pointer' }}>here</a> to add a location.</div> :
          <div style={{ lineHeight: 1.5, fontSize: '14px' }}>
            <div>
              {
                requestingAccess ?
                  <div>
                    <CircularProgress />
                  </div> :
                  <div>
                    <div>
                      The administrator has not given you access to add locations. If you believe this is in error, please click
                      <a
                        style={{ cursor: requestAccessError ? 'not-allowed' : 'pointer', color: requestAccessError ? 'rgb(84, 84, 84)' : '' }}
                        onTouchTap={() => {
                          if (!requestAccessError) requestAccess({ feature: 'the corporate profile', companyType, firstName, lastName });
                        }}
                      > here</a> to request access.
                    </div>
                    <div>
                      {!requestingAccess && requestAccessError && <div style={{ color: 'red', fontSize: '16px', marginTop: '10px' }}>{requestAccessError}</div>}
                    </div>
                  </div>
              }
            </div>
          </div>
      }
    </div>
  );
};

NoLocs.propTypes = {
  corporateAccess: PropTypes.array,
  requestingAccess: PropTypes.bool,
  requestAccessError: PropTypes.string,
  requestAccess: PropTypes.func,
  companyType: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};

const mapDispatchToProps = dispatch => ({
  requestAccess: (payload) => dispatch(requestAccessFromAdmin(payload)),
});

const mapStateToProps = ({ globalErrors, user }) => ({
  companyType: user.getIn(['user', 'type']),
  corporateAccess: user.get('corporateAccess'),
  firstName: user.get('firstName'),
  lastName: user.get('lastName'),
  requestingAccess: globalErrors.get('requestingAccess'),
  requestAccessError: globalErrors.get('requestAccessError'),
});

export default connect(mapStateToProps, mapDispatchToProps)(NoLocs);



// WEBPACK FOOTER //
// ./src/app/components/settings/userManagement/views/noLocs.js